import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceOption } from 'src/app/pages/phones/models/device-option.interface';
import { addSpacesToTypeName } from 'src/app/pipes/split-enum-strings/add-spaces.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { deviceOptionActions } from '../state/device-option.actions';
import { deviceOptionSelectors } from '../state/device-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: DeviceSelectComponent,
        },
    ],
    selector: 'ndt-device-select',
    templateUrl: './device-select.component.html',
    standalone: false
})
export class DeviceSelectComponent extends LcsSingleSelectBase<DeviceOption> implements OnInit {
   @Input() devicesToExclude: DeviceOption[] = [];

   devices: Observable<DeviceOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.devices = this.store.pipe(
         select(deviceOptionSelectors.selectFilteredItems),
         this.itemsLoaded(),
         map((results) => {
            return results.filter((dev) => {
               return !this.devicesToExclude.find((x) => {
                  return x.deviceId === dev.deviceId;
               });
            });
         })
      );
   }

   displayWith(item: DeviceOption | null): string | null {
      return item ? this.getDisplay(item) : null;
   }

   getDisplay(value: DeviceOption): string {
      const device = value;
      if (device.description && device.description.trim() !== '')
         return `${addSpacesToTypeName(device.deviceTypeId)} - ${device.macAddress} (${device.description})`;
      else {
         return `${addSpacesToTypeName(device.deviceTypeId)} - ${device.macAddress}`;
      }
   }

   trackBy(item: DeviceOption | null) {
      return item ? item.deviceId : null;
   }

   refresh(): void {
      this.store.dispatch(
         deviceOptionActions.loadFromApi({
            fields: ['deviceId', 'macAddress', 'deviceTypeId', 'accountId', 'phoneId', 'description'],
            url: '/api/devices',
         })
      );
   }
}
